import { Post } from '../../types';
import ListingTemplate from './ListingTemplate';

const ContactPage = (post: Post) => <ListingTemplate {...post} />;

export default ContactPage;
